import { action, computed, makeObservable } from "mobx";
import { type LoginToken } from "../../api";
import { LocalStorageService } from "../../utils/local-storage";

export type LoginTokenMetadata = {
    context?: "sso";
};

export type LoginTokenWithContext = LoginToken & LoginTokenMetadata;

export class ServiceLoginToken extends LocalStorageService<LoginTokenWithContext | undefined> {
    constructor() {
        super({
            version: 1,
            defaultValue: undefined,
            identifier: "auth",
        });
        makeObservable(this);
    }

    /** Retrieve stored login token. */
    @computed public get loginToken(): LoginTokenWithContext | undefined {
        return this.storedValue;
    }

    @action.bound public setLoginToken(token: LoginTokenWithContext | undefined): void {
        this.storedValue = token;
    }
}
